var chevronDown = "https://shopfront-cdn.tekoapis.com/static/c07673d71acde799.svg";

export { chevronDown as default };
